import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ID} from "../../../core/metamodel/metaConstant";
import {SubCriterionParameterValue} from "./subCriterionParameterValueDomain";
import {LovItem} from "../../../core/metamodel/mdEntity";
import {SubCriterion} from "./subCriterionDomain";

@entityConfig()
export class SubCriterionParameter extends DomainAncestor {

  @observable paramId: number;
  @observable name: string;
  @observable number : number;
  @observable parameters : SubCriterionParameterValue[];
  @observable paramType : PARAMTYPE;
  @observable valueType : VALUETYPE;
  @observable optional : boolean;

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.paramId;
  }

  public setId(id: ID): void {
    this.paramId = <number>id;
  }
}

export enum PARAMTYPE {
  SELECT = "SELECT",
  TEXT = "TEXT",
}

export enum VALUETYPE {
  STRING = "STRING",
  NUMBER = "NUMBER",
  PARAM_ID = "PARAM_ID",
  PERCENTS = "PERCENTS",
  BOOLEAN = "BOOLEAN",
  MULTI = "MULTI"
}



// WEBPACK FOOTER //
// ./src/sbtool/domain/criterion/subCriterionParameterDomain.ts